import React from "react";
import { Tab, Tabs, NavLink, LinearProgress, Heading } from "../../components";
import { makeStyles } from "@material-ui/styles";
import sharedStyles from "../styles";

const useStyles = makeStyles(sharedStyles);

export default function Header({ tabIndex, loading, permissions }) {
  const classes = useStyles();

  return (
    <>
      {loading && <LinearProgress />}
      <div
        className={classes.header}
        style={{ paddingLeft: "0", paddingRight: "0", marginTop: -10 }}>
        {/* <Heading level={3} gutterBottom>
          Definitions
        </Heading> */}
        <Tabs value={tabIndex} className={classes.tabHeader} textColor="primary">
          {permissions?.workflows?.active === "True" && permissions?.workflows?.hide === "False" && <Tab label="Workflows" component={NavLink} path="/workflowDefs" />}
          {permissions?.tasks?.active === "True" && permissions?.tasks?.hide === "False" && <Tab label="Tasks" component={NavLink} path="/taskDefs" />}
          {permissions?.event_handlers?.active === "True" && permissions?.event_handlers?.hide === "False" && <Tab
            label="Event Handlers"
            component={NavLink}
            path="/eventHandlerDef"
          />}
        </Tabs>
      </div>
    </>
  );
}
